import React, { memo, useEffect } from "react";
import Promo from "./Promo/Promo";
import ContactsBlock from "./ContactsBlock/ContactsBlock";
import Feedback from "../../components/Feedback/Feedback";

const Contacts = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Promo />
      <ContactsBlock />
      <Feedback>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2923.586789764488!2d74.60329327595959!3d42.881564971149245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x389eb7ffc19696e3%3A0x4657fc20ef6632b!2sInnovation%20Center!5e0!3m2!1sru!2skg!4v1739949564296!5m2!1sru!2skg" width="560" height="670" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" frameborder="0"></iframe>

      </Feedback>
    </>
  );
};

export default memo(Contacts);

